import { useQuery } from "@tanstack/react-query";

import { api } from "./client";

export interface MeResponse {
  authenticated: boolean;
  email?: string;
  id?: number;
  telegram_paired?: boolean;
  // True once the user has completed POST /api/onboarding/prime.
  // Existing pre-B3 users are backfilled to true via migration.
  onboarded?: boolean;
}

export function useMe() {
  return useQuery<MeResponse>({
    queryKey: ["me"],
    queryFn: async () => (await api.get<MeResponse>("/me")).data,
    staleTime: 60_000,
    retry: false,
  });
}
